// extracted by mini-css-extract-plugin
export default {"container":"style_container__Hkqqj","center_label":"style_center_label__mCF-x"};